import { CheckIcon } from '@chakra-ui/icons'

// the Box Icons check icon is too small within its ViewBox
export const OmCheck = CheckIcon
